module.exports = __webpack_public_path__ + "img/tree.d38a8ed3.png";